import { render, staticRenderFns } from "./PopoverTextarea.vue?vue&type=template&id=15ffa478"
import script from "./PopoverTextarea.vue?vue&type=script&lang=js"
export * from "./PopoverTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports